<template>
  <v-responsive
    class="v-img v-img--booting max-sm:-mb-[150px] max-md:-mb-[300px] max-lg:-mb-[350px] max-sm:-mx-[calc(10px+var(--container-padding-x,16px))] max-lg:max-w-none lg:w-[800px] lg:max-w-[690px]"
    :aspect-ratio="688 / 697"
  >
    <template #additional>
      <nuxt-img
        ref="image"
        src="/homepage/hero-test.jpg"
        placeholder="/homepage/hero-lazy.jpg"
        :preload="{ fetchPriority: 'high' }"
        loading="lazy"
        densities="x2"
        sizes="544px lg:610px xl:690px 2xl:850px"
        alt="Unbiased"
        draggable="false"
        width="850"
        class="v-img__img rounded-circle"
      />
    </template>
  </v-responsive>
</template>

<script setup lang="ts">
</script>
